import styled from "styled-components"

import {IconButton, IconTypes} from "../Button"

interface CloseIconProps {
  top?: string,
  right?: string
}

export const CloseIcon = styled(IconButton).attrs({icon: IconTypes.cross})<CloseIconProps>`
  position: absolute;
  top: ${({top}) => top || 0};
  right: ${({right}) => right || 0};
  cursor: pointer;
`
